import { messageError } from '../../components/message';
import { withAPIAccount } from '../../lib/http/api';
import { APIError, parsedResponse } from '../../lib/http/http';
import { AccountType } from '../../model';
import { IApiGameManageRes } from '../../model/api-modules';
import { IGameEnvModel } from '../../model/api-modules/env';
import { initGameEnvFailedTip } from '../../pages/game-content/lib';
import { IEnvTask } from '../../pages/lib';
import { filterCurAreaEnvList } from '../../pages/utils/env';
import { ADMIN_INGAME_CONSOLE_PROXY_PREFIX, ADMIN_PREFIX } from '../config';

// 获取游戏环境列表---admin侧
export const fetchAdminEnvList = (gameID: string, isCurRegion?: boolean) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/game/${gameID}/env/list`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IGameEnvModel[]>(response, 'data');

      const envs = isCurRegion ? filterCurAreaEnvList(res) : res;
      return envs;
    } catch (error) {
      console.log('failed: fetchAdminEnvList', error);
      initGameEnvFailedTip(gameID, null);
      return null;
    }
  });

// 更新游戏代号---admin侧
export const updateAdminGameCode = (
  gameID: string,
  body: { projectCode?: string; extensionField?: Record<string, any> }
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/game/${gameID}`;
      const response = await api.commonRequest('PATCH', url, {
        gameID,
        ...body,
      });
      await parsedResponse<any>(response, 'code');
      return true;
    } catch (error: any) {
      if (error instanceof APIError) {
        messageError(error.message);
      }
      return false;
    }
  });

export const getGameManagementList = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/game/agg-management-list`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IApiGameManageRes>(response, 'data');
      return res;
    } catch (error) {
      return;
    }
  });

export const supportDeleteGame = (gameID: string, studioID: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/game/${gameID}?studioID=${studioID}`;
      const response = await api.commonRequest('DELETE', url);
      await parsedResponse<any>(response, 'data');
      return true;
    } catch (error) {
      if (error instanceof APIError) {
        messageError(error.message);
      }
      return false;
    }
  });

export const supportDeleteEnv = (
  gameID: string,
  envID: number,
  studioID: string
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/game/${gameID}/${envID}?studioID=${studioID}`;
      const response = await api.commonRequest('DELETE', url);
      await parsedResponse<any>(response, 'data');
      return true;
    } catch (error) {
      if (error instanceof APIError) {
        messageError(error.message);
      }
      return false;
    }
  });

export const supportGetServiceStatusByEnv = (
  gameId: string,
  envId: number,
  envGuid: string
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_INGAME_CONSOLE_PROXY_PREFIX}/v1/api/k8s/ingame/game_service_env/get_service_status?gameID=${gameId}&envID=${envId}&game_id=${gameId}&env_id=${envGuid}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IEnvTask[]>(response, 'result');
      return res?.[0];
    } catch (error: any) {
      return;
    }
  });

// 更新游戏ccid---admin侧
export const updateAdminGameCcid = (
  envURL: string,
  envID: number,
  gameID: string,
  ccid: string
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_INGAME_CONSOLE_PROXY_PREFIX}/v1/api/k8s/ingame/data_bypass/update_game_ccid?gameID=${gameID}&envID=${envID}`;
      const response = await api.commonRequest('POST', url, {
        g6DomainURL: envURL,
        game_id: gameID,
        ccid,
      });
      const res = await parsedResponse<any>(response, 'code');
      return res;
    } catch (error: any) {
      if (error instanceof APIError) {
        messageError(error.message);
      }
      return false;
    }
  });
